<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="pull-center">
          <span>{{ $t("companyManage.companyOrder.title") }}</span>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                      <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search"
                             @keypress.enter="initList">
                      <div class="input-group-append">
                        <button class="all-btn search-btn" @click="initList">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end justify-content-between mt-md-0 mt-2 card-header-btns-box flex-wrap flex-sm-nowrap">
                  <router-link tag="button" class="all-btn m-0"
                               v-if="hasPermission('COMPANY_PERSONAL_CABINET_TARIFF_ADD')" :to="addOrder">
                    <i class="fa fa-plus"></i>
                    <span>{{ $t("companyManage.companyOrder.addTariff") }}</span>
                  </router-link>
                  <router-link tag="button" class="all-btn m-0 ml-0 ml-sm-3 mt-2 mt-sm-0"
                               v-if="hasPermission('COMPANY_PERSONAL_CABINET_TARIFF_ADD')" :to="addOrderPiece">
                    <i class="fa fa-plus"></i>
                    <span>{{ $t("companyManage.companyOrder.addPieceSale") }}</span>
                  </router-link>
              </div>

            </div>
          </div>
          <div class="card-body table-responsive">
            <div class="table-wrapper">
              <table class="table table-hover">
              <thead>
              <tr>
                <th>#</th>
                <th>Тури</th>
                <th>Хизмат Номи</th>
                <th>{{ $t("companyManage.companyOrder.companyClient") }}</th>
                <th>{{ $t("companyManage.companyOrder.contractNumber") }}</th>
                <th>{{ $t("common.qty") }}</th>
                <th>{{ $t("companyManage.companyOrder.feeService") }}</th>
                <th>{{ $t("companyManage.companyOrder.paidAmount") }}</th>
                <th>{{ $t("common.date") }}</th>
                <th>{{ $t("common.status") }}</th>
                <th>{{ $t("common.createdDate") }}</th>
                <th class="text-center">
                  {{ $t("realEstate.field.action") }}
                </th>
              </tr>
              </thead>
              <tbody v-if="!loading && results && results.data">
              <tr v-for="result in results.data" :key="result.id">
                <td>{{ result.id }}</td>
                <td>
                  <span class="badge badge-success" v-if="result.companyOrderType.name==='TARIFF_MONTHLY'">{{result.companyOrderType.text}}</span>
                  <span class="badge badge-secondary" v-else>{{result.companyOrderType.text}}</span>
                </td>
                <td>
                  <div v-if="result.companyTariff">{{ result.companyTariff.name }}</div>
                  <div v-if="result.companyTariffType">{{ result.companyTariffType.text}}</div>
                </td>
                <td>
                  <div v-if="result.companyClient">{{ result.companyClient.name }}</div>
                </td>
                <td class="font-weight-bold">{{ result.contractNumber }}</td>
                <td class="font-weight-bold">{{ result.qty}}</td>
                <td class="font-weight-bold">{{ result.amount | currency('', 2, {thousandsSeparator: ' '}) }}</td>
                <td class="font-weight-bold">{{ result.paidAmount | currency('', 2, {thousandsSeparator: ' '}) }}</td>
                <td class="font-weight-bold">
                  <div v-if="result.startDate && result.dueDate">
                    {{ new Date(result.startDate) | dateFormat('DD/MM/YYYY HH:mm') }}
                    -
                    {{ new Date(result.dueDate) | dateFormat('DD/MM/YYYY HH:mm') }}
                  </div>
                </td>
                <td>
                  <span class="badge badge-success" v-if="result.visibleState==='ACTIVE'">{{ result.visibleState }}</span>
                  <span class="badge badge-secondary"
                        v-else-if="result.visibleState==='DEACTIVATED'">{{ result.visibleState }}</span>
                  <span class="badge badge-danger" v-else>{{ result.visibleState }}</span>
                </td>
                <td>{{ new Date(result.createDate) | dateFormat('DD/MM/YYYY HH:mm') }}</td>
                <td class="text-center td-actions">
                  <div class="form-group">
                    <button class="all-btn add-btn" v-if="!result.paidAmount" @click="payWithUzCard(result)"
                            :disabled="isUzCardLoading">
                      <i class="fa fa-money"></i>
                      <span>{{ $t('common.paymentWithUzCard') }}</span>
                      <loading2 v-if="isUzCardLoading"></loading2>
                    </button>
                  </div>
                  <router-link :to="editOrder(result)"
                               v-tooltip="'Компаниялар тарифни ўзгартириш'"
                               class="all-btn edit-btn table-action"
                               v-if="hasPermission('COMPANY_PERSONAL_CABINET_TARIFF_EDIT')">
                    <i class="fa fa-edit"></i>
                  </router-link>

                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div class="text-center">
              <div class="loader mt-5 mb-5" v-if="loading"></div>
              <span class="no-data mt-5 mb-5"
                    v-if="!loading && results && results.data && results.data.length===0">{{ $t("messages.list.empty") }}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1">
              <div class="col-12 pt-3 pb-3">
                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                              @change="onPageChange">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CurrencyRateByDate/>
    </div>
  </div>
</template>

<script>
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import initFilterModel from '@/shared/filter';
import CurrencyRateByDate from '@/views/config/currency/CurrencyRateByDate';

export default {
  name: "CompanyOrderList",
  components: {
    'b-pagination': bPagination,
    CurrencyRateByDate: CurrencyRateByDate
  },
  data() {
    return {
      loading: false,
      filter: initFilterModel(),
      results: null,
      isUzCardLoading: false,
    }
  },
  computed: {
      addOrder() {
          return '/company-manage/company-order/new';
      },
      addOrderPiece() {
          return '/company-manage/company-order-piece/new';
      },
  },
  methods: {
    initList() {
      this.loading = true;
      this.$http.post('company-order/list', this.filter)
          .then(res => {
            this.results = res.data;
            this.loading = false;
          });
    },
    onPageChange(page) {
      this.filter.page.page = page;
      this.initList();
    },
    payWithUzCard(result) {
      this.isUzCardLoading = true;
      const data = {
        type: 1,
        contractNumber: result.contractNumber,
        summa: result.amount,
        userId: this.$store.state.profile.id,
        companyTin: result.companyClient.companyTin
      };

      this.$http.post('/uzcard/create-url-company-client', data)
          .then((res) => {
            this.isUzCardLoading = false;
            const uzCardUrl = res.data.data;
            if (uzCardUrl && uzCardUrl != 'undefined') {
              var checkUrl = uzCardUrl.includes("https://myuzcard.uz/#/recivepay/");
              if (checkUrl) {
                console.log("Galdi")
                window.open(uzCardUrl, '_blank');
                // window.location.assign(uzCardUrl);
              }
            }
            this.$swal({
              icon: 'error',
              title: 'UzCard',
              text: uzCardUrl
            });
          }, () => {
            this.isUzCardLoading = false;
            console.log('error_on_payWithUzCard');
            this.$swal({
              icon: 'error',
              title: 'UzCard',
              text: 'Server Error'
            });
          });
    },
      editOrder(result) {
          if (result.companyOrderType.name === 'TARIFF_MONTHLY') {
              return '/company-manage/company-order/edit/' + result.id;
          }
          return '/company-manage/company-order-piece/edit/' + result.id;
      }
  },
  created() {
    this.initList();
  }
}
</script>

<style scoped>

</style>
